<template>
  <v-row>
    <v-col cols="12">
      <gg-input-label>Add Recipients</gg-input-label>
      <v-combobox
        class="gg-input"
        multiple
        dense
        outlined
        chips
        deletable-chips
        v-model="model"
        :error-messages="errorMessages"
        :name="name"
      >
        <template slot="append"></template>
      </v-combobox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Contacts',
  model: {
    event: 'input',
  },
  props: {
    name: String,
    errorMessages: Array,
    contacts: {
      type: Object,
    }
  },
  $_veeValidate: {
    // value getter
    model () {
      return this.select
    },
    // name getter
    name () {
      return this.name
    }
  },
  data: () => ({
    model: [],
    rules: {
      email: true
    }
  }),
  methods: {
    parseContacts () {
      for (let key in this.contacts) {
        if (this.contacts.hasOwnProperty(key)) {
          if (this.contacts[key].length !== 0) {
            this.contacts[key].forEach(item => {
              this.model.push(item)
            })
          }
        }
      }
    },
  },
  watch: {
    model (val) {
      this.$emit('input', val)
    },
  },
  created () {
    this.parseContacts()
  }
}
</script>
